module.exports = __webpack_public_path__ + "img/Ma.Maritime.Revetments.Rockrevetment-10m.Rock.ea1bfbd3.png";